import { api } from '../../../../../global/services/api'
import { isObject } from 'lodash'

const TAB_KEY = 'userRoles'
export default {
  data () {
    return {
      userRolesKey: TAB_KEY,
      roleAutocompletesItems: {},
      showUserRolesTabLoader: false
    }
  },

  computed: {
    userRolesCreateConfig () {
      return {
        title: this.$t('base/user.roles'),
        key: TAB_KEY,
        onLoad: () => this.onUserRolesTabLoad(),
        validationErrors: this.validationErrors,
        showLoader: this.showUserRolesTabLoader,
        tabContent: [
          {
            component: this.columnsContentComponent,
            title: this.$t('base/user.roles'),
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'base/master_role_id',
                    label: this.$t('base/user.master_account'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.['base/master'] || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: !!this.permissions?.isMaster
                  },
                  {
                    key: 'base_role_id',
                    label: this.$t('base.users'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.base || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'base/companies_role_id',
                    label: this.$t('base.companies'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.['base/companies'] || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'base/sims_trackers_role_id',
                    label: this.$t('base/sims_trackers.roles_multi_autocomplete_label'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.['base/sims_trackers'] || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'base/reports_role_id',
                    label: this.$t('base.reports'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.['base/reports'] || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'fleet_role_id',
                    label: this.$t('base/modules.fleet'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.fleet || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'sms_role_id',
                    label: 'SMS',
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.sms || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'road-maintenance_role_id',
                    label: this.$t('base/modules.road-maintenance'),
                    type: 'combobox',
                    items: this.roleAutocompletesItems?.['road-maintenance'] || [],
                    autocomplete_options: {
                      custom_display_value: (event) => {
                        return event?.display_name || ''
                      },
                      allowCustomValue: false
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onUserRolesTabLoad () {
      try {
        this.showUserRolesTabLoader = true
        const { data } = await api('base').get('role/auth-user-descendant-roles')
        if (data && isObject(data)) {
          this.roleAutocompletesItems = data
        }
      }
      catch (exception) {
        console.error(exception)
      }
      finally {
        this.showUserRolesTabLoader = false
      }
    }
  }
}
